import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Card, Checkbox, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from '@mui/material';
import EntityConfirmDelete from '../subcomponents/EntityConfirmDelete';
import { DeleteIcon } from '../../Icons';
import CustomIconButton from "../subcomponents/CustomIconButton";
import { useRowSelection } from "../../../hooks/useRowSelection";


const PlaceListResults = ({ places, totalCount, setLimit, limit, setOffset, offset, handleDeletePlace, ...rest }) => {

    const { selectedIds: selectedPlaceIds, handleSelectAll, handleSelectOne } = useRowSelection(places);
    const [page, setPage] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [toDelete, setToDelete] = useState({});

    const handleLimitChange = async (event) => {
        await setLimit(event.target.value);
    };

    const openConfirmDelete = (place) => {
        setToDelete(place);
        setOpenDialog(true);
    }

    const closeDialog = () => setOpenDialog(false);

    const handlePageChange = async (event, newPage) => {
        await setOffset(newPage * limit);
        await setPage(newPage);
    };

    return (
        <div>
            <EntityConfirmDelete
                open={openDialog}
                item={toDelete}
                itemLabel="une salle"
                onClose={closeDialog}
                onConfirm={() => handleDeletePlace(toDelete.uid)}
            />
            <Card {...rest}>
                <Box sx={{ overflowX: 'auto' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        checked={selectedPlaceIds.length === places.length}
                                        color="primary"
                                        indeterminate={
                                            selectedPlaceIds.length > 0
                                            && selectedPlaceIds.length < places.length
                                        }
                                        onChange={handleSelectAll}
                                    />
                                </TableCell>
                                <TableCell size="small">Nom</TableCell>
                                <TableCell size="small">Places</TableCell>
                                <TableCell size="small">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {places.slice(0, limit).map((place) => (
                                <TableRow hover key={place.uid} selected={selectedPlaceIds.indexOf(place.uid) !== -1}>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            checked={selectedPlaceIds.indexOf(place.uid) !== -1}
                                            onChange={(event) => handleSelectOne(event, place.uid)}
                                            value="true"
                                        />
                                    </TableCell>
                                    <TableCell size="small">{place.name}</TableCell>
                                    <TableCell size="small">{place.capacity}</TableCell>
                                    <TableCell size="small">
                                        <CustomIconButton
                                            onClick={() => openConfirmDelete(place)}
                                            title="Supprimer"
                                            icon={<DeleteIcon />} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
                <TablePagination
                    component="div"
                    count={totalCount}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleLimitChange}
                    page={page}
                    rowsPerPage={limit}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                />
            </Card >
        </div >
    );
};

PlaceListResults.propTypes = {
    places: PropTypes.array.isRequired
};

export default PlaceListResults;
